import React from 'react'

const Header = (props) => {
    return (
        <div className="nav-wrapper">
            <div className="navbar-links">
                <button
                    className={props.active === "home" ? "navbar-link active" : "navbar-link"}
                    onClick={()=>props.setActive("home")}
                >
                    <i className="fa fa-fw fa-home mr-2"></i><span>Home</span>
                </button>
                <button
                    className={props.active === "about" ? "navbar-link active" : "navbar-link"}
                    onClick={()=>props.setActive("about")}
                >
                    <i className="fa fa-fw fa-info-circle mr-2"></i><span>About</span>
                </button>
                <button
                    className={props.active === "education" ? "navbar-link active" : "navbar-link"}
                    onClick={()=>props.setActive("education")}
                >
                    <i className="fa fa-fw fa-graduation-cap mr-2"></i><span>Education</span>
                </button>
                <button
                    className={props.active === "experience" ? "navbar-link active" : "navbar-link"}
                    onClick={()=>props.setActive("experience")}
                >
                    <i className="fa fa-fw fa-briefcase mr-2"></i><span>Experience</span>
                </button>
                <button
                    className={props.active === "skills" ? "navbar-link active" : "navbar-link"}
                    onClick={()=>props.setActive("skills")}
                >
                    <i className="fa fa-fw fa-code mr-2"></i><span>Skills</span>
                </button>
                <button
                    className={props.active === "projects" ? "navbar-link active" : "navbar-link"}
                    onClick={()=>props.setActive("projects")}
                >
                    <i className="fa fa-fw fa-tasks mr-2"></i><span>Work</span>
                </button>
                <button
                    className={props.active === "interests" ? "navbar-link active" : "navbar-link"}
                    onClick={()=>props.setActive("interests")}
                >
                    <i className="fa fa-fw fa-paint-brush mr-2"></i><span>Interests</span>
                </button>
            </div>
        </div>
    )
}

export default Header